module.exports = __webpack_public_path__ + "img/filter-type-cooldown.ac0cff10.svg";